export default __webpack_public_path__ + "static/app-templates-1-d7e714d0f9f2ab1bcb8819371c8d5a7a.png";